import React, { createContext } from 'react';

import { usePersistedState } from 'hooks/PersistedState';
import PropTypes from 'prop-types';

export const ArticlesAndEventsContext = createContext({});

export const ArticlesAndEventsContextProvider = ({ children }) => {
  const [limit, setLimit] = usePersistedState('limit', 10);

  return (
    // it's a custom hook to save thins in the local storage, not much we can do about it
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ArticlesAndEventsContext.Provider value={{ limit, setLimit }}>
      {children}
    </ArticlesAndEventsContext.Provider>
  );
};
ArticlesAndEventsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
